import { NavigationArea } from '@skykick/core';

export const ProductType = {
  Migration: '6425aa2c-3ad0-413f-b0d4-c97732a92e15',
  Backup: '7283c36c-c6bf-4984-af30-6a965c32b892',
  SaaSSecurity: '7d9ba0b2-3d5b-4a1c-b040-279001f73893',
  Account: '43f5040f-9183-438d-abd3-d5b9eeb2c7a3',
  Billing: '43f5040f-9183-438d-abd3-d5b9eeb2c7a5',
}

export const Products = [
  {
    name: 'cloudbackup',
    notificationsName: 'Backup',
    displayName: 'sk-notifications-admin-center.tabs.cloudbackup',
    id: ProductType.Backup,
    navigationArea: NavigationArea.CloudBackup,
  },
  {
    name: 'cloudmigration',
    notificationsName: 'Migration',
    displayName: 'sk-notifications-admin-center.tabs.cloudmigration',
    id: ProductType.Migration,
    navigationArea: NavigationArea.Migrations,
  },
];
